import React, { useEffect, useState } from "react";

const NumUsersContainer = () => {
  const [userStats, setUserStats] = useState([]);

  useEffect(() => {
    console.log("Fetching users from Firestore...");
    window.firebase
      .firestore()
      .collection("users")
      .where("email", ">", "")
      .limit(1000)
      .get()
      .then((querySnapshot) => {
        const users = [];
        let processedCount = 0;
        querySnapshot.forEach((doc) => {
          processedCount++;
          if (processedCount % 100 === 0) {
            console.log(`${processedCount} users processed...`);
          }
          const userData = doc.data();
          if (userData.email && userData.email.trim() !== '') {
            users.push(userData);
          }
        });

        const stats = calculateStats(users);
        console.log("Finished processing users, updating stats...");
        setUserStats(stats);
      });
  }, []);

  const calculateStats = (users) => {
    const stats = {};

    users.forEach((user) => {
      const registeredYear = new Date(user.registeredOn * 1000).getFullYear(); // Convert Unix timestamp to milliseconds
      const lastLoginYear = user.lastLogin?.toDate().getFullYear();

      if (!stats[registeredYear]) {
        stats[registeredYear] = { signedUp: 0, active: 0 };
      }
      stats[registeredYear].signedUp += 1;

      if (lastLoginYear) {
        if (!stats[lastLoginYear]) {
          stats[lastLoginYear] = { signedUp: 0, active: 0 };
        }
        stats[lastLoginYear].active += 1;
      }
    });

    return Object.entries(stats).map(([year, { signedUp, active }]) => ({
      year,
      signedUp,
      active,
    }));
  };

  return (
    <div>
      <h2>User Insights</h2>
      <table>
        <thead>
          <tr>
            <th>Year</th>
            <th>Users Signed Up</th>
            <th>Active Users</th>
          </tr>
        </thead>
        <tbody>
          {userStats.map((stat) => (
            <tr key={stat.year}>
              <td>{stat.year}</td>
              <td>{stat.signedUp}</td>
              <td>{stat.active}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default NumUsersContainer;
